/**
 * Counties outside Missouri that the HERE probe network reaches -- the Kansas
 * and Illinois halves of the Kansas City and St Louis metros, plus the
 * interstates running out of the state.
 *
 * Their names come from the segment geometry: HERE ships these with no county
 * at all, and MoDOT's own boundaries cannot name them. Qualified by state,
 * because Johnson, St Clair and a dozen more county names sit on both sides of
 * a state line. Listed here only where the network has at least 10 TMCs.
 */
export const outOfStateCounties = [
  { name: 'Johnson (KS)', value: ['JOHNSON, KS'] },
  { name: 'Wyandotte (KS)', value: ['WYANDOTTE, KS'] },
  { name: 'Madison (IL)', value: ['MADISON, IL'] },
  { name: 'St Clair (IL)', value: ['ST CLAIR, IL'] },
  { name: 'Sedgwick (KS)', value: ['SEDGWICK, KS'] },
  { name: 'Shawnee (KS)', value: ['SHAWNEE, KS'] },
  { name: 'Sangamon (IL)', value: ['SANGAMON, IL'] },
  { name: 'Saline (KS)', value: ['SALINE, KS'] },
  { name: 'Ottawa (KS)', value: ['OTTAWA, KS'] },
  { name: 'Logan (IL)', value: ['LOGAN, IL'] },
  { name: 'Douglas (KS)', value: ['DOUGLAS, KS'] },
  { name: 'Macon (IL)', value: ['MACON, IL'] },
  { name: 'Geary (KS)', value: ['GEARY, KS'] },
  { name: 'Effingham (IL)', value: ['EFFINGHAM, IL'] },
  { name: 'Butler (KS)', value: ['BUTLER, KS'] },
  { name: 'Montgomery (IL)', value: ['MONTGOMERY, IL'] },
  { name: 'Morgan (IL)', value: ['MORGAN, IL'] },
  { name: 'Crawford (KS)', value: ['CRAWFORD, KS'] },
  { name: 'Adams (IL)', value: ['ADAMS, IL'] },
  { name: 'Reno (KS)', value: ['RENO, KS'] },
  { name: 'Republic (KS)', value: ['REPUBLIC, KS'] },
  { name: 'Sumner (KS)', value: ['SUMNER, KS'] },
  { name: 'Williamson (IL)', value: ['WILLIAMSON, IL'] },
  { name: 'Lincoln (KS)', value: ['LINCOLN, KS'] },
  { name: 'Riley (KS)', value: ['RILEY, KS'] },
  { name: 'Harvey (KS)', value: ['HARVEY, KS'] },
  { name: 'Franklin (KS)', value: ['FRANKLIN, KS'] },
  { name: 'Ellis (KS)', value: ['ELLIS, KS'] },
  { name: 'Monroe (IL)', value: ['MONROE, IL'] },
  { name: 'Lyon (KS)', value: ['LYON, KS'] },
  { name: 'Mitchell (KS)', value: ['MITCHELL, KS'] },
  { name: 'Cloud (KS)', value: ['CLOUD, KS'] },
  { name: 'Smith (KS)', value: ['SMITH, KS'] },
  { name: 'Jewell (KS)', value: ['JEWELL, KS'] },
  { name: 'Ellsworth (KS)', value: ['ELLSWORTH, KS'] },
  { name: 'Ford (KS)', value: ['FORD, KS'] },
  { name: 'Gove (KS)', value: ['GOVE, KS'] },
  { name: 'Thomas (KS)', value: ['THOMAS, KS'] },
  { name: 'Osborne (KS)', value: ['OSBORNE, KS'] },
  { name: 'Mcdonough (IL)', value: ['MCDONOUGH, IL'] },
  { name: 'Wilson (KS)', value: ['WILSON, KS'] },
  { name: 'Sherman (KS)', value: ['SHERMAN, KS'] },
  { name: 'Rooks (KS)', value: ['ROOKS, KS'] },
  { name: 'Fayette (IL)', value: ['FAYETTE, IL'] },
  { name: 'Fulton (IL)', value: ['FULTON, IL'] },
  { name: 'De Witt (IL)', value: ['DE WITT, IL'] },
  { name: 'Mcpherson (KS)', value: ['MCPHERSON, KS'] },
  { name: 'Saline (IL)', value: ['SALINE, IL'] },
  { name: 'Cherokee (KS)', value: ['CHEROKEE, KS'] },
  { name: 'Jefferson (IL)', value: ['JEFFERSON, IL'] },
  { name: 'Alexander (IL)', value: ['ALEXANDER, IL'] },
  { name: 'Pike (IL)', value: ['PIKE, IL'] },
  { name: 'Trego (KS)', value: ['TREGO, KS'] },
  { name: 'Phillips (KS)', value: ['PHILLIPS, KS'] },
];
